<template>
  <div class="card card-nav-tabs mt-4 rounded-lg border-0 shadow-lg container p-4">
      <div class="">
          <button class="btn btn-primary-dark btn-sm rounded text-xxs shadow mb-1 mt-3"
              data-bs-toggle="modal"
              data-bs-target="#invoice_payment">
          Upload POP
          </button>
      </div>
      <!-- Payment Proofs Section -->
      <h5 class="mt-4 text-xxs">Payment Proofs</h5>
      <div class="table-responsive mt-2">
        <table class="table table-hover">
          <thead class="custom-header">
            <tr>
              <th class="text-start text-xxs ps-3">ID</th>
              <th class="text-start text-xxs ps-3">Date Uploaded</th>
              <th class="text-start text-xxs ps-3">Document</th>
              <th class="text-start text-xxs ps-3">Status</th>
              <th class="text-start text-xxs ps-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="proof in proofs" :key="proof.id">
              <td class="text-xxs ps-3">{{ proof.id }}</td>
              <td class="text-xxs ps-3">{{ formatDate(proof.date_uploaded) }}</td>
              <td class="text-xxs ps-3">
                {{ proof.document.split('/').pop() }}
              </td>
              <td class="text-xxs ps-3">{{ proof.status }}</td>
              <td class="ps-3">
                <button
                  class="btn btn-primary-dark btn-sm text-xxs me-2"
                  @click="openProof(proof.document_url)"
                  data-bs-toggle="modal"
                  data-bs-target="#proof_modal"
                >
                  View
                </button>
                <button
                  class="btn btn-primary-dark btn-sm text-xxs me-2"
                  @click="openCommentModal(proof.id,'approve')"
                  data-bs-toggle="modal"
                  data-bs-target="#commentModal"
                  >Approve</button>

                  <button
                      class="btn btn-primary-dark btn-sm text-xxs"
                      @click="openCommentModal(proof.id,'reject')"
                      data-bs-toggle="modal"
                      data-bs-target="#commentModal"
                  >Reject</button>
              </td>
            </tr>
            <tr v-if="proofs.length === 0">
              <td colspan="4" class="text-center text-xxs text-muted">
                No proof of payments found.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Proof Preview Modal -->
      <teleport to="body">
      <div
        class="modal fade"
        id="proof_modal"
        tabindex="-1"
        aria-labelledby="proofModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
            <div class="modal-header border-bottom-0 cute-header shadow-lg">
              <h5 class="modal-title text-white text-xxs" id="proofModalLabel">Preview Proof</h5>
              <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="ratio ratio-4x3">
                <iframe
                  v-if="currentProofUrl"
                  :src="currentProofUrl"
                  frameborder="0"
                  width="100%"
                  height="100%"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      </teleport>

      <!-- Comment Modal -->
      <teleport to="body">
      <div
        class="modal fade"
        id="commentModal"
        tabindex="-1"
        aria-labelledby="commentModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
            <div class="modal-header border-bottom-0 cute-header shadow-lg">
              <h5 class="modal-title text-white text-xxs" id="commentModalLabel">
                Comments
              </h5>
              <button
                type="button"
                class="btn-close modal-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div class="modal-body">
              <!-- Amount input -->
              <div class="mb-3">
                <label for="amount" class="form-label">Amount</label>
                <input
                  type="number"
                  v-model="amount"
                  class="form-control"
                  id="amount"
                  placeholder="Enter amount"
                  min="0"
                  step="0.01"
                />
              </div>

              <!-- Comments textarea -->
              <div class="mb-3">
                <label class="form-label">Comments (optional)</label>
                <textarea
                  v-model="commentText"
                  class="form-control"
                  rows="4"
                  placeholder="Enter your comments…"
                ></textarea>
              </div>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-primary-dark btn-sm text-xxs"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                class="btn btn-primary-dark btn-sm text-xxs"
                @click="submitComment"
                data-bs-dismiss="modal"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
      </teleport>

      <!-- Upload Modal-->
      <teleport to="body">
    <div class="modal fade" id="invoice_payment" tabindex="-1" aria-labelledby="invoice_payment_label" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
              <div class="modal-header border-bottom-0 cute-header shadow-lg">
                  <p class="modal-title text-white text-xxs" id="invoice_payment_label">Upload proof of payment</p>
                  <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <div class="modal-body">

                    <div class="modal-form-group form-group mb-3 d-flex flex-column mt-2">
                      <label for="invoice_payment" class="modal-form-label form-label text-start text-xxs">
                        Proof of payment (PDF only):
                      </label>

                      <!-- Only allow PDF files -->
                      <input  class="form-control text-xxs"
                              type="file"
                              id="template_file"
                              accept="application/pdf"
                              @change="handle_file_selection"/>
                    </div>

                    <!-- PDF Preview -->
                    <div v-if="preview_url" class="mt-3">
                      <iframe
                        v-if="is_previewable"
                        :src="preview_url"
                        width="100%"
                        height="500px">
                      </iframe>
                      <div v-else>
                        <p>Preview unavailable for this file type.</p>
                      </div>
                    </div>
              </div>

              <div class="modal-footer border-0 p-2 d-flex justify-content-end mb-2">
                  <button @click="submit_payment_proof"
                          type="button"
                          class="btn btn-primary-dark btn-sm text-xxs shadow-sm">
                      Upload
                  </button>
              </div>
          </div>
      </div>
    </div>
    </teleport>
  </div>
</template>